import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './tour.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import Box from '@mui/material/Box';
import { Link, useParams } from 'react-router-dom'
import { packageGet } from '../../api/package'
import { getImageUrl } from '../../utils/imageUrl'
// -------------------------------------------------

const Tours = () => {
  const params = useParams()

  const [tourData, setTourData] = useState([])

  console.log(params)
  const getPackage = async () => {

    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    const corporate = resp.data?.filter((item) => {
      return item?.packageMode === 'Corporate'
    })
    const category = resp.data?.filter((item) => {
      return item?.type === params?.cat
    })
    console.log(category)
    if (params.id === 'International') {
      setTourData(filterInterNational)
    } else if (params?.id === 'Domestic') {
      setTourData(national)
    } else if (params?.id === 'Corporate') {
      setTourData(corporate)
    } else {
      setTourData(category)
    }


  }

  useEffect(() => {
    getPackage()
  }, [])
  return (
    <>
      <Header />
      <section className='specialOffers mt-3'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">{params?.id} Packages</h4>
            </div>
          </div>
          <div className='row'>
            {tourData?.map((items) => (
              <div className="col-md-6 col-xl-4 py-2">
                <Link to={`/tourDetail/${items._id}`} >
                  <div className="destination">
                    <Box className="eximg-group g-bg-4 tourIm">
                      <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                      <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                    </Box>
                    <div className='py-2'>
                      <div className="py-2">
                        <h5 className="card-title">
                          <a href="#!">{items.packageName}</a>
                        </h5>
                      </div>
                      <div className="hstack gap-2">
                        <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                        <small>Starting price</small>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
            {/* <div className="col-md-6 col-xl-4 py-2">
              <Link to="/tourDetalil" >
                <div className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src='images/thailand.jpg' alt='' />
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">Lombok, Indonesia</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">$1385</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-md-6 col-xl-4 py-2">
              <Link to="/tourDetalil" >
                <div className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src='images/thailand.jpg' alt='' />
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">Lombok, Indonesia</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">$1385</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              </Link>
            </div> */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Tours